/** A request failed before an HTTP response; the server may still have committed a write. */
export class NetworkUnavailableError extends Error {
  constructor(cause: unknown) {
    super("暂时无法连接写作服务，请在连接恢复后重试。", { cause });
    this.name = "NetworkUnavailableError";
  }
}

export async function fetchResponse(input: RequestInfo | URL, options?: RequestInit): Promise<Response> {
  try {
    return await fetch(input, options);
  } catch (error) {
    if (options?.signal?.aborted || error instanceof Error && error.name === "AbortError") throw error;
    throw new NetworkUnavailableError(error);
  }
}
